import { Box, Typography } from "@mui/material"
import { fileUrl } from "api/api"
import { ArticleProps } from "api/application/manageWeb-interface"
import { notiError } from "component/notifications/notifications"
import { ContentState, EditorState } from "draft-js"
import htmlToDraft from "html-to-draftjs"
import SwitchButton from "new-components/buttons/switch-button"
import TextAreaInput from "new-components/inputs/text-area-input"
import InputTextEditor from "new-components/inputs/text-editor"
import TextInput from "new-components/inputs/text-input"
import UploadImage from "new-components/upload/upload-image"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"



type ArticleFormProps = {
    dataEdit: any
    setDataEdit: (data: any) => void
    errorMessage: any
}

const ArticleForm = (props: ArticleFormProps) => {
    const { t } = useTranslation()
    const maxHeight = 1080
    const maxWidth = 1080
    const t_ARTICLE = "MANAGE_WEB.ARTICLE"

    const [dataEdit, setDataEdit] = useState<any>(props.dataEdit)
    const [dataEditId, setDataEditId] = useState<any>(props.dataEdit)
    const [editorState, setEditorState] = useState<any>(EditorState.createEmpty())

    const onLoadEdit = () => {
        const data = {
            ...props.dataEdit,
            status: !props.dataEdit?.articleId && "ACTIVE" || props.dataEdit?.status
        }
        setDataEdit(data)
        setDataEditId(data)
        if (data?.content) {
            const newHTML: any = data?.content
            const blocksFromHTML = htmlToDraft(newHTML);
            const content = ContentState.createFromBlockArray(
                blocksFromHTML.contentBlocks,
                blocksFromHTML.entityMap,
            );
            setEditorState(EditorState.createWithContent(content))
        }
    }

    useEffect(() => {
        onLoadEdit()
    }, [])

    const uploadNewsImageSign = (files: any) => {
        if (files[0]) {
            const file = files[0];
            const fileName = file.name.split(".");
            const detailImage = {
                base64: "",
                type: dataEditId?.fileType || "",
                fileExtension: fileName[fileName.length - 1],
                fileSize: file.size.toString(),
                fileId: dataEditId?.articleId || 0,
            };
            const reader: any = new FileReader();
            reader.addEventListener("load", () => {
                const image = new Image();
                image.src = reader?.result as string;
                image.addEventListener("load", () => {
                    const width = image.width;
                    const height = image.height;

                    if (maxHeight < height || maxWidth < width) {
                        const errorWidth = maxWidth < width && ` ${t('MANAGE_WEB.BANNER.ERROR_WIDTH')} ${maxWidth} ` || ''
                        const errorHeight = maxHeight < height && ` ${t('MANAGE_WEB.BANNER.ERROR_HEIGHT')} ${maxHeight} ` || ''
                        const error = `รูปภาพ ${errorWidth} ${maxHeight < height && maxWidth < width && " และ " || ''} ${errorHeight}`
                        notiError(error)
                    } else {
                        const base64 = reader.result.split(",");
                        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result;
                        const newData = { ...dataEdit, ...detailImage, base64Show: reader.result, }
                        setDataEdit(newData)
                    }
                });
            });
            reader.readAsDataURL(file);
        }
    };


    useEffect(() => {
        renderDataSave()
    }, [editorState, dataEdit])

    const renderDataSave = () => {
        let newDataFile = {}
        if (dataEdit?.base64Show) {
            newDataFile = {
                file: {
                    fileId: dataEdit?.articleId || 0,
                    base64: dataEdit?.base64 || '',
                    type: dataEdit?.fileType || '',
                    fileExtension: dataEdit?.fileExtension || '',
                    fileSize: dataEdit?.fileSize || ''
                }
            }
        }
        const info: ArticleProps = {
            status: dataEdit?.status,
            topic: dataEdit?.topic || '',
            subTopic: dataEdit?.subTopic || '',
            content: dataEdit?.content || '',
        }

        const newData: ArticleProps = { ...info, ...newDataFile }
        props?.setDataEdit(newData)
    }

    return (
        <Box>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                maxHeight: {
                    xs: '70vh',
                    sm: '70vh',
                    md: '70vh',
                    lg: '65vh',
                    xl: '70vh',
                },
                paddingRight: '16px',
                overflowY: 'auto',
            }}>
                <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box sx={{ paddingTop: '8px', width: '50%' }}>
                        <TextInput
                            label={t(`${t_ARTICLE}.LABEL_HEADTEXT`)}
                            value={dataEdit?.topic}
                            onChange={(e: any) => {
                                setDataEdit({ ...dataEdit, topic: e.target.value })
                            }}
                            fullWidth
                            required
                            helperText={props.errorMessage.EMPTY_TOPIC}
                        />
                    </Box>
                    <Box sx={{ marginTop: '16px', justifyContent: 'flex-end' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="16px" gap={2} >
                            <Typography fontSize="16px" fontWeight={400}>{t(`${t_ARTICLE}.LABEL_STATUS`)}</Typography>
                            <SwitchButton checked={dataEdit?.status === 'ACTIVE' ? true : false} onChange={() => setDataEdit({ ...dataEdit, status: dataEdit?.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE' })} />
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ marginTop: '8px', width: '50%' }}>
                    <Box sx={{ fontWeight: '500' }}>{t(`${t_ARTICLE}.UP_PIC`)}</Box>
                    <Box sx={{ marginTop: '12px', height: dataEdit?.filePath || dataEdit?.base64Show ? 'auto' : '350px' }}>
                        <Box sx={{ width: "100%", height: "100%", ".MuiFormControl-root": { height: '100%' } }}>
                            <UploadImage
                                canDelete={true}
                                onDelete={() => setDataEdit({ ...dataEdit, base64Show: '', filePath: '', fileName: '', fileType: '' })}
                                setValue={uploadNewsImageSign}
                                pathFile={dataEdit?.base64Show || dataEdit?.filePath && `${fileUrl}/${dataEdit?.filePath}/${dataEdit?.fileName}` || ''}
                                height={'100%'}
                                maxWidth={maxWidth}
                                maxHeight={maxHeight}
                            />
                            <Box sx={{ color: "#BBBBBB", marginTop: "8px" }}>
                                {'('}{t(`${t_ARTICLE}.FILESIZE`)}{` ${maxWidth} x ${maxHeight} px)`}
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ marginTop: '48px' }}>
                    <TextAreaInput
                        label={t(`${t_ARTICLE}.LABEL_SUBTOPIC`)}
                        value={dataEdit?.subTopic}
                        onChange={(e) => {
                            setDataEdit({ ...dataEdit, subTopic: e.target.value })
                        }}
                        fullWidth
                    />
                </Box>
                <Box sx={{ marginTop: '48px' }}>
                    <Box sx={{ fontWeight: '500' }}> {t(`${t_ARTICLE}.DETAIL`)} </Box>
                    <Box width={'100%'} marginTop={'16px'}>
                        {(dataEdit?.articleId) && (
                            <InputTextEditor
                                value={dataEdit?.content}
                                setValue={(e) => {
                                    setDataEdit({ ...dataEdit, content: e })
                                }}
                            />
                        ) || <></>}
                        {(!dataEdit?.articleId) && (
                            <InputTextEditor
                                value={dataEdit?.content}
                                setValue={(e) => {
                                    setDataEdit({ ...dataEdit, content: e })
                                }}
                            />
                        ) || <></>}
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}

export default ArticleForm